package one.healthium.uscreen.ui.di

import one.healthium.uscreen.ui.UScreenViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val uscreenUiModule = module {
    viewModelOf(::UScreenViewModel)
}
